import { useMutation, useQueryClient } from "react-query";

import { crearTicket, updateTicket, deleteTicket} from '../../services/Tikets';

import { toast } from 'react-hot-toast';
const queryKey = "ticket";

export const useTicketsMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addTicket = useMutation((body) => crearTicket(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
 
  const updateTicketC = useMutation(
    (body) => updateTicket( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeTicket = useMutation((id) => deleteTicket( id), {
    onSuccess,
    onError,
  });

  return { addTicket, updateTicketC, removeTicket };
};
export default useTicketsMutations;